import { html } from 'lit';

export const iconCart = html`
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 0.5C3.34375 0.5 3.65625 0.78125 3.71875 1.125L3.78125 1.5H16.9062C17.5625 1.5 18.0625 2.15625 17.875 2.78125L16.1875 8.78125C16.0625 9.21875 15.6875 9.5 15.2188 9.5H5.3125L5.59375 11H15.25C15.6562 11 16 11.3438 16 11.75C16 12.1875 15.6562 12.5 15.25 12.5H4.96875C4.625 12.5 4.3125 12.25 4.25 11.9062L2.375 2H0.75C0.3125 2 0 1.6875 0 1.25C0 0.84375 0.3125 0.5 0.75 0.5H3ZM4 15C4 14.1875 4.65625 13.5 5.5 13.5C6.3125 13.5 7 14.1875 7 15C7 15.8438 6.3125 16.5 5.5 16.5C4.65625 16.5 4 15.8438 4 15ZM16 15C16 15.8438 15.3125 16.5 14.5 16.5C13.6562 16.5 13 15.8438 13 15C13 14.1875 13.6562 13.5 14.5 13.5C15.3125 13.5 16 14.1875 16 15Z"
    />
  </svg>
`;
